/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema } from '../schema';
import { Data2, data2Schema } from './data2';
import { Links, linksSchema } from './links';
import { Meta, metaSchema } from './meta';

export interface AC101Retrieveconsentedaccountsinformation {
  data: Data2;
  links: Links;
  meta: Meta;
}

export const aC101RetrieveconsentedaccountsinformationSchema: Schema<AC101Retrieveconsentedaccountsinformation> = object(
  {
    data: ['Data', lazy(() => data2Schema)],
    links: ['Links', lazy(() => linksSchema)],
    meta: ['Meta', lazy(() => metaSchema)],
  }
);
